import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';
import logo from '../images/gheika_logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { i18n, t } = useTranslation();

  const navItems = [
    { name: t('nav.home'), href: '#inicio' },
    { name: t('nav.services'), href: '#servicios' },
    { name: t('nav.projects'), href: '#proyectos' },
    { name: t('nav.team'), href: '#equipo' },
    { name: t('nav.contact'), href: '#contacto' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img src={logo} alt="Gheika Logo" className="h-8 w-auto" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="text-gray-300 hover:text-red-500 transition-colors duration-200 font-medium"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Language Switcher and CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <div className="flex space-x-2">
              <Button
                onClick={() => i18n.changeLanguage('en')}
                className={`px-3 py-1 text-sm font-medium rounded-lg transition-all duration-200 ${
                  i18n.language === 'en'
                    ? 'bg-red-600 text-white hover:bg-red-700'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                EN
              </Button>
              <Button
                onClick={() => i18n.changeLanguage('es')}
                className={`px-3 py-1 text-sm font-medium rounded-lg transition-all duration-200 ${
                  i18n.language === 'es'
                    ? 'bg-red-600 text-white hover:bg-red-700'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                ES
              </Button>
            </div>
            <Button
              onClick={() => scrollToSection('#contacto')}
              className="bg-red-600 hover:bg-red-700 text-white font-medium px-6 py-2 rounded-lg transition-all duration-200 hover:shadow-lg"
            >
              <Phone className="w-4 h-4 mr-2" />
              {t('nav.contactUs')}
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-white transition-colors"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-gray-900 border-t border-gray-800">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollToSection(item.href)}
                  className="block w-full text-left px-3 py-2 text-gray-300 hover:text-red-500 transition-colors duration-200"
                >
                  {item.name}
                </button>
              ))}
              <div className="flex space-x-2 px-3 py-2">
                <Button
                  onClick={() => i18n.changeLanguage('en')}
                  className={`flex-1 px-3 py-1 text-sm font-medium rounded-lg transition-all duration-200 ${
                    i18n.language === 'en'
                      ? 'bg-red-600 text-white hover:bg-red-700'
                      : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  }`}
                >
                  EN
                </Button>
                <Button
                  onClick={() => i18n.changeLanguage('es')}
                  className={`flex-1 px-3 py-1 text-sm font-medium rounded-lg transition-all duration-200 ${
                    i18n.language === 'es'
                      ? 'bg-red-600 text-white hover:bg-red-700'
                      : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  }`}
                >
                  ES
                </Button>
              </div>
              <div className="pt-4">
                <Button
                  onClick={() => scrollToSection('#contacto')}
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-2 rounded-lg transition-all duration-200"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  {t('nav.contactUs')}
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;